module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-eight1.90d2924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-eight1.png
// module id = htuU
// module chunks = 0